import {RefObject, useEffect, useRef} from "react";

export function useScrollTo<T extends HTMLElement>(isScroll: boolean): RefObject<T | null> {
    const ref = useRef<T>(null);

    useEffect(() => {
        if (isScroll && ref.current) {
            ref.current.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }, [isScroll]);

    return ref;
}
